import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
    // ✅ Get token from localStorage
    const token = localStorage.getItem("authToken");

    if (!token) {
        // 🔒 Not logged in -> redirect to login page
        return <Navigate to="/" replace />;
    }

    // ✅ Logged in -> render child components
    return children;
};

export default ProtectedRoute;
